<template>
    <FormSelect v-model="value" :options="options" :null-option="nullOption" :null-option-text="nullOptionText" />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import FormSelect from './FormSelect.vue';

const props = defineProps({
    modelValue: {
        required: true,
    },
    disabled: {
        required: false,
        type: Boolean,
        default: false,
    },
    options: {
        required: true,
        type: Array,
    },
    nullOption: {
        required: false,
        type: Boolean,
        default: true,
    },
    nullOptionText: {
        required: false,
        type: String,
        default: '',
    },
    groupId: {
        required: true,
        type: [Number, String, null],
    },
});
let emit = defineEmits(['update:modelValue']);
const value = useVModel(props, 'modelValue', emit);

const options = ref(props.options);
watch(
    () => props.groupId,
    (groupId) => {
        if (groupId) {
            fetchStudents(groupId);
        } else {
            value.value = null;
            options.value = [];
        }
    },
);

const fetchStudents = (groupId) => {
    axios
        .get(route('select.group_students.show', { group: groupId }))
        .then((response) => {
            value.value = null;
            options.value = response.data.items;
        })
        .catch((error) => {
            console.log(error);
        });
};

defineOptions({
    name: 'FormSelectGroupStudents',
});
</script>
